export const materials = [
  {
    label: "adhesives_cements_sealants",
    options: [
      "adhesives",
      "adhesive_cement",
      "caulking",
      "cement",
      "duct_adhesive",
      "finishing_cement",
      "furnace_cement",
      "insulating_cement",
      "joint_cement",
      "masonry_cement",
      "putties",
      "mortar",
      "plastic_cement",
      "sealant",
    ],
  },
  {
    label: "asbestos_paper_board_roll",
    options: [
      "asbestos_paper",
      "corrugated_paper",
      "flexible_board",
      "millboard",
      "permanent_board",
      "roll",
      "vinyl_wallpaper",
    ],
  },
  {
    label: "automotive_materials_friction",
    options: [
      "brake_linings",
      "brake_pads",
      "brakes",
      "clutch_linings",
      "disc_brakes",
      "drum_brakes",
      "elevator_brake_shoes",
      "transmission_plates",
    ],
  },
  {
    label: "cement_pipes_boards_sheets_plastics",
    options: [
      "asbestos_board",
      "asbestos_sheets",
      "cement_pipes",
      "plastics",
      "stone_coating",
    ],
  },
  {
    label: "clay_compounds_paints_plasters",
    options: [
      "acoustic_plaster",
      "asphalt",
      "filler",
      "finishing",
      "joint_compound",
      "paint",
      "patching",
      "plaster",
      "putty",
      "putty_compounds",
    ],
  },
  {
    label: "electrical_mechanical_products",
    options: [
      "boilers",
      "cables_wires",
      "electrical_boards",
      "furnaces",
      "generators",
      "heating_ducts",
      "pumps",
      "turbines",
      "valve_rings",
      "valves",
      "weather_resistant_jackets",
      "wiring_insulation",
    ],
  },
  {
    label: "flooring_tiles",
    options: [
      "ceiling_tiles",
      "tiles",
      "flooring",
      "slabs",
      "vinyl_linoleum_floors",
      "wall_tiles",
    ],
  },
  {
    label: "gaskets_packings_sealing_materials",
    options: [
      "braided_packing",
      "gasket_material",
      "gaskets",
      "packing_material",
      "rope_packing",
      "sheet_packing",
    ],
  },
  {
    label: "household_products",
    options: [
      "agricultural_filler",
      "attic_insulation",
      "cigarette_filters",
      "clay_pots",
      "fertilizer",
      "exhaust_hoods",
      "iron_stands",
      "ironing_board_covers",
      "lab_hoods",
      "potting_mixes",
      "stove_mats",
    ],
  },
  {
    label: "panels_drywall_wall_coverings",
    options: [
      "acoustic_panels",
      "drywall",
      "marine_panel",
      "panels",
      "gypsum_board",
      "wallboard",
    ],
  },
  {
    label: "pipe_covering_block",
    options: [
      "block_insulation",
      "calcium_silicate",
      "duct_insulation",
      "insulation",
      "magnesia",
      "pipe_insulation",
      "preformed_pipe_wrap",
      "sponge_block",
      "sleeveless_jacket",
    ],
  },
  {
    label: "protective_clothing",
    options: [
      "aprons",
      "asbestos_helmet",
      "dust_masks",
      "glassblowers_mittens",
      "gloves",
      "lab_gloves",
      "mittens",
      "respirators",
      "sleeves",
      "textile_garments",
    ],
  },
  {
    label: "protective_fireproof_coatings",
    options: [
      "asbestos_curtains",
      "asbestos_spray",
      "boiler_coating",
      "fireproof_blankets",
      "fire_dampers",
      "fire_doors",
      "fireproof_cement",
      "fireproof_materials",
      "insulating_coating",
      "roof_coating",
      "textured_coatings",
      "coating",
    ],
  },
  {
    label: "raw_asbestos",
    options: [
      "asbestos_fiber",
      "fake_snow",
      "raw_asbestos",
      "calsilite_silicate",
      "talc_powder",
      "transite",
      "vermiculite",
    ],
  },
  {
    label: "refractory_products",
    options: [
      "castables",
      "refractory_brick",
      "marinite",
      "refractory_cement",
      "refractory_products",
    ],
  },
  {
    label: "rope_wick_cord_tape_cork",
    options: [
      "asbestos_cord",
      "asbestos_rope",
      "cork_coating",
      "foil_rope",
      "tape",
      "wicking",
    ],
  },
  {
    label: "textiles_felts_fabrics",
    options: [
      "asbestos_blanket",
      "asbestos_canvas",
      "asbestos_fabric",
      "asbestos_felt",
      "asbestos_lap",
      "asbestos_wool",
      "asbestos_thread",
      "lagging",
      "roving",
      "textiles",
    ],
  },
];

// export const materials = [
//   {
//     label: "1 - Adhesivos, Cementos, Selladores",
//     options: [
//       "Adhesivos",
//       "Cemento adhesivo",
//       "Calafateo",
//       "Cemento",
//       "Adhesivo para conductos",
//       "Cemento de acabado",
//       "Cemento de horno",
//       "Cemento aislante",
//       "Cemento para juntas",
//       "Cemento Masónico",
//       "Masillas",
//       "Mortero",
//       "Cemento Plástico",
//       "Sellador",
//     ],
//   },
//   {
//     label: "2 - Papel de asbesto, Cartón enrollable, Cartón",
//     options: [
//       "Papel de amianto",
//       "Papel corrugado",
//       "Tablero flexible",
//       "Millboard",
//       "Tablero permanente",
//       "Rollo",
//       "Papel pintado de vinilo",
//     ],
//   },
//   {
//     label: "3 - Materiales Automotrices, Fricción",
//     options: [
//       "Forros de freno",
//       "Pastillas de freno",
//       "Frenos",
//       "Forros de embrague",
//       "Frenos de disco",
//       "Frenos de tambor",
//       "Zapatas de freno de ascensor",
//       "Placas de transmisión",
//     ],
//   },
//   {
//     label: "4 - Tuberías de Cemento, Placas de Cemento, Láminas, Plásticos",
//     options: [
//       "Tablero de amianto",
//       "Hojas de amianto",
//       "Tuberías de cemento",
//       "Plásticos",
//       "Revestimiento de piedra",
//     ],
//   },
//   {
//     label: "5 - Arcilla, Compuestos, Pinturas, Yesos",
//     options: [
//       "Yeso Acústico",
//       "Asfalto",
//       "Relleno",
//       "Finalizar",
//       "Compuesto para juntas",
//       "Pintar",
//       "Parcheo",
//       "Yeso",
//       "Masilla",
//       "Compuestos de masilla",
//     ],
//   },
//   {
//     label: "6 - Productos eléctricos y mecánicos",
//     options: [
//       "Calderas",
//       "Cables y alambres",
//       "Tableros Eléctricos",
//       "Hornos",
//       "Generadores",
//       "Conductos de calefacción",
//       "Bombas",
//       "Turbinas",
//       "Anillos de válvula",
//       "Válvulas",
//       "Chaquetas resistentes a la intemperie",
//       "Aislamiento de cableado",
//     ],
//   },
//   {
//     label: "7 - Suelos, Azulejos",
//     options: [
//       "Tejas del techo",
//       "Baldosas",
//       "Suelos",
//       "Losas",
//       "Pisos de vinilo y linóleo",
//       "Azulejos de pared",
//     ],
//   },
//   {
//     label: "8 - Juntas, Empaques, Materiales de Empaque",
//     options: [
//       "Embalaje trenzado",
//       "Material de junta",
//       "Juntas",
//       "Material de empaque",
//       "Embalaje de cuerda",
//       "Embalaje de hojas",
//     ],
//   },
//   {
//     label: "9 - Productos de uso doméstico",
//     options: [
//       "Relleno Agrícola",
//       "Aislamiento del ático",
//       "Filtros de cigarrillos",
//       "Ollas de barro",
//       "Fertilizante",
//       "Campanas de extracción",
//       "Soportes de hierro",
//       "Fundas para tablas de planchar",
//       "Campanas de laboratorio",
//       "Mezclas para macetas",
//       "Alfombrillas para estufa",
//     ],
//   },
//   {
//     label: "10 - Paneles, Paneles de Yeso, Revestimientos de Paredes",
//     options: [
//       "Paneles Acústicos",
//       "Paneles de yeso",
//       "Panel marino",
//       "Paneles",
//       "Placa de yeso",
//       "Panel de yeso",
//     ],
//   },
//   {
//     label: "11 - Cubierta y bloque de tuberías",
//     options: [
//       "Aislamiento de bloques",
//       "Silicato de calcio",
//       "Aislamiento de conductos",
//       "Aislamiento",
//       "Magnesia",
//       "Aislamiento de tuberías",
//       "Envoltura de tubería preformada",
//       "Bloque de esponja",
//       "Chaqueta sin mangas",
//     ],
//   },
//   {
//     label: "12 - Ropa protectora",
//     options: [
//       "Delantales",
//       "Casco de amianto",
//       "Máscaras antipolvo",
//       "Manoplas para sopladores de vidrio",
//       "Guantes",
//       "Guantes de laboratorio",
//       "Mitones y manoplas",
//       "Respiradores",
//       "Mangas",
//       "Prendas Textiles",
//     ],
//   },
//   {
//     label: "13 - Recubrimientos protectores, ignífugos",
//     options: [
//       "Cortinas de amianto",
//       "Aerosol de amianto",
//       "Revestimiento de calderas",
//       "Mantas ignífugas",
//       "Compuertas cortafuegos",
//       "Puertas de fuego",
//       "Cemento ignífugo",
//       "Materiales ignífugos",
//       "Revestimiento aislante",
//       "Revestimiento de techo",
//       "Recubrimientos texturizados",
//       "Recubrimiento",
//     ],
//   },
//   {
//     label: "14 - Amianto crudo",
//     options: [
//       "Fibra de amianto",
//       "Nieve falsa",
//       "Amianto en bruto",
//       "Silicato de calsilita",
//       "Polvo de talco",
//       "Tránsito",
//       "Vermiculita",
//     ],
//   },
//   {
//     label: "15 - Productos refractarios",
//     options: [
//       "Castables",
//       "Ladrillo refractario",
//       "Marinita",
//       "Cemento refractario",
//       "Productos refractarios",
//     ],
//   },
//   {
//     label: "16 - Cuerda, Mecha, Cordón, Cinta, Corcho",
//     options: [
//       "Cordón de amianto",
//       "Cuerda de amianto",
//       "Revestimiento de corcho",
//       "Cuerda de lámina",
//       "Cinta",
//       "Wicking",
//     ],
//   },
//   {
//     label: "17 - Textiles, Fieltros, Telas",
//     options: [
//       "Manta de amianto",
//       "Lona de amianto",
//       "Tela de amianto",
//       "Fieltro de amianto",
//       "Vuelta de amianto",
//       "Lana de amianto",
//       "Hilo de amianto",
//       "Rezagado",
//       "Itinerante",
//       "Textiles",
//     ],
//   },
// ];
